



































































import { mapActions, mapGetters, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import BuyItButton from '~/components/car/classifieds/view/partials/BuyItButton.vue'
import { ClassifiedDiscount, PricePerUnit } from '~/models/classified/types'
import { USER_NS } from '~/store/modules/shared/user/state'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'

export default defineComponent({
  components: {
    CPrice,
    BuyItButton,
    CClassifiedFavoriteButton
  },
  props: {
    pricePerUnit: {
      type: Object as PropType<PricePerUnit>,
      default: null
    },
    price: {
      type: Object,
      required: true
    },
    discount: {
      type: Object as PropType<ClassifiedDiscount>,
      default: null
    },
    externalLink: {
      type: Object,
      default: null
    },
    offersEnabled: {
      type: Boolean,
      default: false,
      required: false
    },
    financeSubtext: {
      type: Boolean,
      default: false,
      required: false
    },
    hiddenFinanceText: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      categoryIds: state => state.classified?.category_ids,
      classifiedId: state => state.classified?.id,
      currentUser: state => state.currentUser
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isPlotClassified: 'isPlotClassified',
      isPartClassified: 'isPartClassified',
      showLoanSection: 'showLoanSection',
      showFinance: 'showFinance',
      userIsOwner: 'isOwn'
    }),
    ...mapGetters(USER_NS, {
      isAnon: 'isAnon'
    }),
    showClassifiedNumber() {
      return Boolean(this.isPartClassified && this.classifiedId)
    },
    hasButtonBeforePrice() {
      return this.isPlotClassified || this.externalLink
    },
    priceParked() {
      return this.price.extra?.price_parked || this.price.extra?.priceParked
    },
    priceToShow() {
      return this.priceParked ? this.priceParked + ' €' : this.price.value
    },
    discountToShow() {
      if (this.priceParked) {
        return this.price.value
      }
      return this.discount?.from_price
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      scrollToFinance: 'scrollToFinance',
      classifiedParkedStateChanged: 'classifiedParkedStateChanged'
    })
  }
})
